import React, { useState } from 'react';
import { Modal, PrimaryButton, SecondaryButton } from '..';

import css from './TransactionRequestModal.module.css';

const isoDate = d => {
  if (!(d instanceof Date) || isNaN(d)) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const parseIsoDate = s => {
  if (!s) return null;
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  return isNaN(dt) ? null : dt;
};

const TransactionRequestModal = props => {
  const {
    id,
    isOpen,
    onClose,
    onManageDisableScrolling,
    requestType,
    currentStartDate,
    currentEndDate,
    inProgress,
    error,
    onSubmit,
  } = props;

  const isCancellation = requestType === 'cancellation';
  const isDateChange = requestType === 'date-change';

  const [reason, setReason] = useState('');
  const [newStart, setNewStart] = useState(isoDate(currentStartDate));
  const [newEnd, setNewEnd] = useState(isoDate(currentEndDate));

  const title = isCancellation
    ? 'Request to cancel this booking'
    : 'Request new dates';
  const description = isCancellation
    ? "The other party can accept or decline. If accepted, the booking is cancelled and the renter is refunded."
    : "Propose new dates. The other party can accept or decline. The existing booking stays in place until they respond.";

  const startDate = parseIsoDate(newStart);
  const endDate = parseIsoDate(newEnd);
  const datesValid = !isDateChange || (startDate && endDate && startDate < endDate);
  const reasonValid = reason.trim().length > 0;
  const canSubmit = !inProgress && reasonValid && datesValid;

  const handleSubmit = e => {
    e.preventDefault();
    if (!canSubmit) return;
    if (isCancellation) {
      onSubmit({ reason: reason.trim() });
    } else {
      onSubmit({
        reason: reason.trim(),
        newStart: startDate.toISOString(),
        newEnd: endDate.toISOString(),
      });
    }
  };

  return (
    <Modal
      id={id}
      containerClassName="marketplaceModalBaseStyles"
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage="Cancel"
    >
      <p className="marketplaceModalTitleStyles">{title}</p>
      <p className="marketplaceModalParagraphStyles">{description}</p>

      <form className={css.form} onSubmit={handleSubmit}>
        {isDateChange ? (
          <div className={css.row}>
            <label className={css.field}>
              <span className={css.label}>New start date</span>
              <input
                type="date"
                className={css.input}
                value={newStart}
                onChange={e => setNewStart(e.target.value)}
                required
              />
            </label>
            <label className={css.field}>
              <span className={css.label}>New end date</span>
              <input
                type="date"
                className={css.input}
                value={newEnd}
                onChange={e => setNewEnd(e.target.value)}
                required
              />
            </label>
          </div>
        ) : null}

        <label className={css.field}>
          <span className={css.label}>Reason</span>
          <textarea
            className={css.textarea}
            value={reason}
            onChange={e => setReason(e.target.value)}
            placeholder={
              isCancellation
                ? 'Why do you need to cancel?'
                : 'Why are you requesting a date change?'
            }
            rows={3}
            required
          />
        </label>

        {error ? <p className={css.error}>{error}</p> : null}

        <div className={css.actions}>
          <SecondaryButton type="button" onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton type="submit" inProgress={inProgress} disabled={!canSubmit}>
            Send request
          </PrimaryButton>
        </div>
      </form>
    </Modal>
  );
};

export default TransactionRequestModal;
